<template>
  <b-modal
    id="login"
    v-model="isLoginModalShow"
    size="sm"
    centered
    :lazy="isLoading"
    no-close-on-backdrop
    body-class="position-static"
    content-class="overflow-hidden"
  >
    <template #modal-header>
      <h4 class="mb-0 text-gray700">{{ $t('登入') }}</h4>
      <b-icon-x
        class="d-block text-40 cursor-pointer"
        @click="closeModal"
      ></b-icon-x>
    </template>
    <b-form @submit.prevent="requestLogin">
      <b-form-group label-for="identificationNo" class="account-input">
        <b-form-input
          v-model="formData.identificationNo"
          name="identificationNo"
          :state="formData.isIdentificationNoValid"
          :placeholder="$t('請輸入證件')"
        ></b-form-input>
        <b-form-invalid-feedback
          v-if="isInvalid"
          class="d-block"
          :class="
            !$v.formData.identificationNo.$invalid
              ? 'text-white'
              : 'text-danger'
          "
        >
          *{{ $t('請輸入證件') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-for="password">
        <b-form-input
          v-model="formData.password"
          name="password"
          type="password"
          :state="formData.isPasswordValid"
          :placeholder="$t('請輸入密碼')"
        ></b-form-input>
        <b-form-invalid-feedback
          v-if="isInvalid"
          class="d-block"
          :class="!$v.formData.password.$invalid ? 'text-white' : 'text-danger'"
        >
          <span v-if="!$v.formData.password.required">{{
            $t('*請輸入密碼')
          }}</span>
          <span v-else-if="!$v.formData.password.minLength">{{
            $t('*不能少于8码')
          }}</span>
        </b-form-invalid-feedback>
      </b-form-group>
      <span
        class="text-underline text-secondary mt-6 cursor-pointer"
        @click="go2ForgetPassword"
      >
        {{ $t('忘記密碼？') }}
      </span>
      <b-button
        pill
        type="submit"
        class="w-100 mt-8"
        size="lg"
        variant="secondary"
      >
        {{ $t('登入') }}
      </b-button>
    </b-form>
    <template #modal-footer>
      <div class="cursor-pointer" @click="go2Signup">
        <span class="m-0 text-underline text-gray700">{{
          $t('還沒有帳號？前往')
        }}</span>
        <span class="text-underline text-secondary m-0 cursor-pointer"
          >{{ $t('註冊') }}
        </span>
      </div>
    </template>
    <b-overlay :show="isLoading" no-wrap rounded class="text-center">
      <template #overlay>
        <div class="d-flex align-items-center">
          <p class="loading-spinner m-0">
            <span class="icon-Loading text-32"></span>
          </p>

          <div class="ml-4">{{ $t('載入中') }}</div>
        </div>
      </template>
    </b-overlay>
  </b-modal>
</template>

<script>
import {required} from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      formData: {
        identificationNo: '',
        password: '',
      },
      isInvalid: false,
      backendError: '',
      isLoading: false,
    };
  },
  validations: {
    formData: {
      identificationNo: {required},
      password: {required},
    },
  },
  computed: {
    isLoginModalShow() {
      return this.$store.getters['env/isLoginModalShow'];
    },
    user() {
      return this.$store.getters['auth/userData'];
    },
    requireAuth() {
      return this.$route.matched.some((route) => route.meta.requireAuth);
    },
    hasMobile() {
      return this.$store.getters['auth/hasMobile'];
    },
  },
  methods: {
    closeModal() {
      window.scrollTo({
        top: -1,
        behavior: 'smooth',
      });

      document.getElementById('layoutContentMain').scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.$nextTick(() => {
        this.$store.commit('env/setLoginModalShow', false);
        if (this.user?.id == null && this.requireAuth) {
          this.$router.push({name: 'home'});
        }
      });
    },
    async requestLogin() {
      await this.loginUser();
    },
    async loginUser() {
      this.$store.commit('env/setIsLoading', true);
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isInvalid = true;
        return;
      }
      try {
        this.isLoading = true;
        this.$store.commit('env/setIsLoading', true);
        await this.$store.dispatch('auth/login', {
          identificationNo: this.formData.identificationNo,
          password: this.formData.password,
        });
        await this.$store.dispatch('auth/getMe');
        await this.$store.dispatch('exam/getCurrentExams', this.user.id);

        this.closeModal();
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
        this.$store.commit('env/setIsLoading', false);
      }
    },
    go2Signup() {
      this.closeModal();
      this.$router.push({name: 'signup'});
    },
    go2ForgetPassword() {
      this.closeModal();
      this.$router.push({name: 'forget-password'});
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .modal-header {
  padding: 24px 28px 24px 40px;
  align-items: center;
  border: none;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: inset 0px -1px 1px #dddddd;
}
::v-deep .modal-body {
  padding: 24px 40px;
  background-color: $gray-100;
  @media screen and (max-width: 768px) {
    padding: 24px;
  }
}

::v-deep .modal-footer {
  padding: 24px 40px;
  justify-content: center;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: inset 0px 1px 1px #dddddd;
  > * {
    margin: 0;
  }
}
::v-deep .modal-sm {
  max-width: 410px;
}

.form-group {
  position: relative;
  margin-bottom: 24px;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  .invalid-feedback {
    position: absolute;
    bottom: -20px;
  }
}
.b-icon {
  color: $gray-700;
}
.form-control {
  font-size: 20px;
  color: $gray-500;
  border-radius: 8px;
  height: 42px;
}

.error {
  margin-top: 4px;
  height: 16px;
  color: $danger;
  font-size: 12px;
  text-align: start;
}
</style>
